const _ = require('lodash'), { trolleyQuantityValidation } = require('./trolley-quantity-validation.constant');

let _shopperService;
let _gtmService;
let _trolleySourceCz;
let _breakpointsService;
let _analyticsService;
let _eventsDtm;
let _settingsService;

const addToTrolleyAnalyticsMapper = require('./gtmmapper/trolley-analytics-mapper');
const addAllToTrolleyAnalyticsMapper = require('./gtmmapper/trolley-addall-analytics-mapper');
const productClickTrolleyAnalyticsMapper = require('./gtmmapper/trolley-productclick-analytics-mapper');
const productClickAddAllTrolleyAnalyticsMapper = require('./gtmmapper/trolley-addallproductclick-analytics-mapper');
const dynamicContentAnalyticsMapper = require('./gtmmapper/dynamic-content-analytics-mapper');

const trolleyDtmMapper = require('./dtmmapper/trolley-analytics-mapper');

/* This service contains combined changes from
 * story WOS-2279 (move filtering to server side)
 * and story WOS-2281 (reduce client side watchers)
 */

const TrolleyService = function TrolleyService($rootScope, restangular, $q, gtm, bootstrap, loginService, shopperService, settingsService,
    deliveryPassService, inspirationService, trolleySource, breakpointsService, richRelevanceService, featureService, analyticsService) {
    /*
     * Service for interacting with the trolley.
     * Supports actions like adding, removing, updating, and clearing.
     * Depends on Restangular.
     */
    this._trolleyRoute = restangular.one('Trolley');

    this.$rootScope = $rootScope;

    this.$q = $q;

    this._loginService = loginService;
    _shopperService = shopperService;
    _gtmService = gtm;
    _trolleySourceCz = trolleySource.collectionZone;
    _analyticsService = analyticsService;
    _eventsDtm = analyticsService.eventsDtm;
    _settingsService = settingsService;
    this.inspirationService = inspirationService;
    this.guestTrolleyLoginReminderShown = false;
    // The items
    this.trolleyProducts = [];

    // Products that are being added or removed on user action for analytics
    this.recentlyChangedItems = [];

    // Totals information
    this.salePriceTotal = 0;
    this.listPriceTotal = 0;
    this.deliveryFee = 0;
    this.savedPrice = 0;

    this.isTotalReady = false;
    this.wowRewardsSummary = {};

    this.srMessage = ''; // this is for sr (Screen Reader) only.

    this.deliveryPassService = deliveryPassService;

    // First initialization
    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.Trolley)) {
        this._updateTrolley(bootstrap.getBootstrappedData(bootstrap.bootstrapped.Trolley));
    }

    this.deliveryPassLimitReached = {};

    this.showDCPdeliveryPassLimitReachedMsg = false;

    this.maxItemsAllowedForGuestUser = 5; // default value

    settingsService.getSettingValue('Trolley', 'GuestUserMaxItemCount').then((response) => {
        this.maxItemsAllowedForGuestUser = parseInt(response);
    });

    this.updateRequestCount = 0;

    _breakpointsService = breakpointsService;

    this.richRelevanceService = richRelevanceService;

    this.featureService = featureService;

    this.$rootScope.$on('trolley:invalidatePricing', () => { this._invalidatePricing(); });
};

TrolleyService.prototype._invalidatePricing = function () {
    this.getTrolley();
};

function getAllProducts() {
    return _.compact(_.concat(this.trolleyProducts, this.unavailableProducts, this.restrictedProducts, this.restrictedByDeliveryMethodProducts, this.restrictedProductsByDeliPlatters));
}

TrolleyService.prototype._updateTrolley = function (response) {
    this.trolleyProducts = response.AvailableItems;
    this.unavailableProducts = response.UnavailableItems;
    this.restrictedByDeliveryMethodProducts = response.RestrictedByDeliveryMethodItems;
    this.restrictedByDeliveryMethodMessage = response.RestrictedByDeliveryMethodMessage;
    this.restrictedProductsByDeliPlatters = response.RestrictedByDeliPlattersItems;
    this.restrictedProducts = _.concat(response.RestrictedItems, response.RestrictedByDeliPlattersItems);

    this.trolleyProductsByStockcode = _.keyBy(getAllProducts.call(this), i => i.Stockcode);

    this.itemCount = response.TrolleyItemCount;
    this.totalItemQuantity = response.TotalTrolleyItemQuantity;
    this.maximumOrderQuantity = response.MaximumOrderQuantity;

    if (this.deliveryPassService) {
        this.deliveryPassService.deliveryPassPrompt = response.ShopperDeliveryPassPromptResponse;
    }

    // Update Totals
    this.salePriceTotal = response.Totals.Total;
    this.savedPrice = response.Totals.TotalSavings;
    this.deliveryFee = response.DeliveryFee.Total;
    this.wowRewardsSummary = response.WowRewardsSummary;
    this.isTotalReady = true;

    // refresh dtm data layer
    this._pushTrolleyDataToDtm(response);

    return response;
};

TrolleyService.prototype.validateDeliveryPassLimit = function (product, quantity) {
    return this._trolleyRoute.post('ValidateDeliveryPass', {
        Stockcode: product.Stockcode,
        Quantity: quantity,
    });
};

TrolleyService.prototype.validateQuantity = function (product, quantity) {
    if (quantity === '' || isNaN(quantity)) {
        return { isValid: false, reason: trolleyQuantityValidation.INVALID_QUANTITY };
    }

    if (this.deliveryPassLimitReached[product.Stockcode]) {
        return { isValid: false, reason: trolleyQuantityValidation.DELIVERY_PASS_LIMIT_EXCEEDED };
    }

    if (quantity > product.SupplyLimit) {
        return { isValid: false, reason: trolleyQuantityValidation.SUPPLY_LIMIT_EXCEEDED };
    }

    if (quantity < product.MinimumQuantity) {
        return { isValid: false, reason: trolleyQuantityValidation.INVALID_QUANTITY };
    }

    return { isValid: true, reason: '' };
};

TrolleyService.prototype._manageErrorMessage = function (product, errorType) {
    const trolleyItem = this.trolleyProductsByStockcode[product.Stockcode];

    if (!this.errors) {
        this.errors = {};
    }

    this.errors[product.Stockcode] = errorType;

    if (trolleyItem != null) {
        trolleyItem.HasError = errorType;
    }
};

TrolleyService.prototype._setScreenReaderMessage = function (stockcode, state) {
    const item = this.getTrolleyItem(stockcode);
    if (!item) {
        // If the item is no longer in the trolley for some reason, shortcut the method.
        // This can happen when trying to add too many delivery passes to the trolley.
        return;
    }

    switch (state) {
        case 'add':
            this.srMessage = `${item.Name} ${item.PackageSize} added to trolley. Quantity: ${item.Quantity}`;
            break;
        case 'update':
            this.srMessage = `${item.Name} ${item.PackageSize} quantity in trolley has been updated to ${item.Quantity}`;
            break;
        case 'remove':
            this.srMessage = `${item.Name} ${item.PackageSize} removed from trolley`;
            break;
        case 'clear':
            this.srMessage = 'All products have been removed from the trolley.';
            break;
        case 'clearOOS':
            this.srMessage = 'All out of stock products have been removed from the trolley.';
            break;
    }
};

TrolleyService.prototype.getTrolley = function () {
    this.isTotalReady = false;

    return this._trolleyRoute.get()
        .then(this._updateTrolley.bind(this));
};

TrolleyService.prototype.getTrolleyItem = function (stockcode) {
    let product = null;

    if (this.trolleyProductsByStockcode) {
        product = this.trolleyProductsByStockcode[stockcode];
    }

    if (!product) {
        product = _.find(this.trolleyProducts, { Stockcode: stockcode });
    }

    if (!product) {
        product = _.find(this.restrictedProducts, { Stockcode: stockcode });
    }

    if (!product) {
        product = _.find(this.unavailableProducts, { Stockcode: stockcode });
    }

    return product;
};

TrolleyService.prototype._pushAddOrRemoveItemToDtm = function (response, isRemovingItemFromTrolley) {
    if (isRemovingItemFromTrolley) {
        _analyticsService.pushEvent(_eventsDtm.REMOVE_FROM_CART);
        this._pushTrolleyDataToDtm(response);
    } else {
        _analyticsService.pushEvent(_eventsDtm.ADD_TO_CART);
        this._pushTrolleyDataToDtm(response);
    }
};
TrolleyService.prototype._pushTrolleyDataToDtm = function (response) {
    let rewardsPointsConversionBase = 1;
    if (_settingsService.settings && _settingsService.settings.loyalty && _settingsService.settings.loyalty.rewardsConversionBase) {
        rewardsPointsConversionBase = _settingsService.settings.loyalty.rewardsConversionBase;
    }
    _analyticsService.push({ data: { Trolley: response, cartChange: this.recentlyChangedItems, rewardsPointsConversionBase }, dtmMapperFn: trolleyDtmMapper });
};

function formatTrolleyProductSource(source) {
    if (_breakpointsService.isInSmallFormat) {
        return `SF.${source}`;
    }
    if (_breakpointsService.isInMediumFormat) {
        return `MF.${source}`;
    }
    if (_breakpointsService.isInLargeFormat) {
        return `LF.${source}`;
    }

    return '';
}

/**
 * Rejects promises for trolley updates if a later update has been made.
 *
 * Since most trolley API calls return the entire trolley aggregate, it is a waste of resources and also
 * disruptful to the UI to update the trolley when we get a response that has been superseded by a later call.
 *
 * @param {Promise} promise - This promise will be rejected (even if the network call was successful)
 *  if a later request is made (even if the later request fails).
 * @param {boolean} [shouldSerialize=true] - Bypasses the serialization behaviour for
 *  deployment switch purposes.
 * @returns {Promise}
 */
TrolleyService.prototype._rejectIfLaterUpdate = function (promise, shouldSerialize = true) {
    if (!shouldSerialize) {
        return promise;
    }

    this.updateRequestCount++;
    const requestVersion = this.updateRequestCount;

    return promise.then(response => (requestVersion >= this.updateRequestCount ? response : this.$q.reject('superseded')));
};

function postToTrolley(product, quantity, source, searchTerm) {
    this.isTotalReady = false;

    return this._rejectIfLaterUpdate(this._trolleyRoute.post('Items', { stockcode: product.Stockcode, quantity, source: formatTrolleyProductSource(source), searchTerm, diagnostics: product.Diagnostics }))
        .then((response) => {
            this._updateTrolley(response);
            this._setScreenReaderMessage(product.Stockcode, 'add');
            return response;
        }).then((response) => {
            this.$rootScope.$broadcast('trolley:update');

            // TODO: may merge this push to the next push
            const cardId = this.inspirationService.getContentCardId();
            if (cardId && source !== _trolleySourceCz) {
                _gtmService.push(cardId, dynamicContentAnalyticsMapper);
            }
            const gtmItems = response.RecentlyAddedItems[0];
            gtmItems.Source = product.Source;
            _gtmService.push(gtmItems, productClickTrolleyAnalyticsMapper);
            _gtmService.push(gtmItems, addToTrolleyAnalyticsMapper);

            this.recentlyChangedItems = [this.getTrolleyItem(product.Stockcode)];
            this._pushAddOrRemoveItemToDtm(response, false);
            if (this.featureService.isEnabled(this.featureService.features.enableRichRelevanceRecommendations)) {
                this.richRelevanceService.addToTrolleyRequest(product, this.trolleyProducts);
            }

            return response;
        });
}

TrolleyService.prototype.addItemToTrolley = function (product, quantity, source, searchTerm) {
    if (!this.validateQuantity(product, quantity).isValid) {
        return this.$q.reject('Invalid');
    }

    const shouldShowLoginReminderForMaxItems = (this.itemCount === (this.maxItemsAllowedForGuestUser - 1) && !this.guestTrolleyLoginReminderShown);
    if (_shopperService.IsGuest && (product.AgeRestricted || shouldShowLoginReminderForMaxItems)) {
        let loginMessage;
        if (product.AgeRestricted) {
            loginMessage = this._loginService.LoginToAddRestrictedProductMessage;
        } else if (shouldShowLoginReminderForMaxItems) {
            loginMessage = this._loginService.LoginToAddMoreProductsMessage;
        } else {
            loginMessage = undefined;
        }

        this.guestTrolleyLoginReminderShown = true;
        return this._loginService.promptForLogin(loginMessage, null, null, null, () => {
            if (_shopperService.AllowRestrictedDepartment) {
                postToTrolley.call(this, product, quantity, source, searchTerm);
            }
        });
    }

    // While we're waiting for the trolley response, use the shelf product for now
    // so the user can see the item in the trolley immediately.
    this.trolleyProducts.unshift(product);

    return postToTrolley.call(this, product, quantity, source, searchTerm);
};

// IIS 6 does not support PUT or DELTE verbs,
// until the server is updated to support these verbs
// we have to use RPC style calls using the POST verb.
function getUpdatePromise(doRpc, params) {
    return doRpc
        ? this._trolleyRoute.post('UpdateItem', params)
        : this._trolleyRoute.one('Items', params.stockcode).put(params);
}

TrolleyService.prototype.updateTrolleyItem = function (product, quantity, updateSource, isRemovingItemFromTrolley) {
    this.isTotalReady = false;

    // copy the updated product and set the quantity to be the amount added or removed. Store this for analytics later.
    const changedProduct = this.getTrolleyItem(product.Stockcode);

    // The product may not be in the trolley yet (waiting on a network response)
    if (changedProduct) {
        const deltaProduct = _.extend({}, changedProduct, { Quantity: Math.abs(changedProduct.Quantity - quantity) });
        this.recentlyChangedItems = [deltaProduct];
    }

    return this._rejectIfLaterUpdate(getUpdatePromise.call(this, true, { stockcode: product.Stockcode, quantity }))
        .then((response) => {
            this._updateTrolley(response);
            this._setScreenReaderMessage(product.Stockcode, 'update');
            return response;
        }).then((response) => {
            this.$rootScope.$broadcast('trolley:update');

            // TODO: may merge this push to the next push
            const cardId = this.inspirationService.getContentCardId();
            if (cardId && updateSource !== _trolleySourceCz) {
                _gtmService.push(cardId, dynamicContentAnalyticsMapper);
            }
            const gtmItems = response.RecentlyAddedItems[0];
            gtmItems.Source = updateSource;

            _gtmService.push(gtmItems, productClickTrolleyAnalyticsMapper);
            _gtmService.push(gtmItems, addToTrolleyAnalyticsMapper);
            this._pushAddOrRemoveItemToDtm(response, isRemovingItemFromTrolley);
            return response;
        });
};

TrolleyService.prototype.removeTrolleyItem = function (stockcode) {
    this.isTotalReady = false;

    // Immediately remove the product from the trolley products list so the UI
    // can update while we wait for the trolley response.
    this.recentlyChangedItems = [
        ..._.remove(this.trolleyProducts, { Stockcode: stockcode }),
        ..._.remove(this.unavailableProducts, { Stockcode: stockcode }),
        ..._.remove(this.restrictedByDeliveryMethodProducts, { Stockcode: stockcode }),
        ..._.remove(this.restrictedProducts, { Stockcode: stockcode }),
    ];

    return this._rejectIfLaterUpdate(this._trolleyRoute.doPOST({ Stockcode: stockcode }, 'Remove'))
        .then((response) => {
            this._setScreenReaderMessage(stockcode, 'remove');
            this._updateTrolley(response);
            this._pushAddOrRemoveItemToDtm(response, true);
            this.$rootScope.$broadcast('trolley:update');
            return response;
        });
};

TrolleyService.prototype.removeItems = function (stockcodes) {
    this.isTotalReady = false;

    this.recentlyChangedItems = _.filter(getAllProducts.call(this), product => _.includes(stockcodes, product.Stockcode));

    return this._rejectIfLaterUpdate(this._trolleyRoute.doPOST({ Stockcodes: stockcodes }, 'RemoveItems'))
        .then((response) => {
            this._updateTrolley(response);
            this._pushAddOrRemoveItemToDtm(response, true);
            this.$rootScope.$broadcast('trolley:update');
        });
};

TrolleyService.prototype.clearOutOfStockTrolleyItems = function () {
    this.isTotalReady = false;
    this.getTrolley().then(() => {
        const outOfStockItemsStockcodes = _.map(this.unavailableProducts, 'Stockcode');
        this.removeItems(outOfStockItemsStockcodes)
            .then((response) => {
                this._setScreenReaderMessage('', 'clearOOS');
                return response;
            });
    });
};

TrolleyService.prototype.clearTrolley = function () {
    this.isTotalReady = false;

    this.recentlyChangedItems = getAllProducts.call(this);
    return this._rejectIfLaterUpdate(this._trolleyRoute.doPOST({}, 'Clear'))
        .then((response) => {
            this._updateTrolley(response);
            this._pushAddOrRemoveItemToDtm(response, true);
            this.$rootScope.$broadcast('trolley:update');
            this._setScreenReaderMessage('', 'clear');
        });
};

TrolleyService.prototype.addItemsToTrolley = function (items) {
    this.isTotalReady = false;
    const mappedProducts = _.map(_.filter(items, product => product.IsAvailable === true && product.DisplayQuantity > 0), (item) => {
        const newQty = item.QuantityInTrolley !== 0 ? item.QuantityInTrolley + item.DisplayQuantity : item.DisplayQuantity;
        return { stockcode: item.Stockcode, quantity: newQty, source: item.Source };
    });

    return this._rejectIfLaterUpdate(this._trolleyRoute.post('AddItems', { products: mappedProducts }))
        .then((response) => {
            this._updateTrolley(response);
            this._setScreenReaderMessage('', 'items added');
            return response;
        }).then((response) => {
            this.$rootScope.$broadcast('trolley:update');

            // TODO: may merge this push to the next push
            const cardId = this.inspirationService.getContentCardId();
            if (cardId) {
                _gtmService.push(cardId, dynamicContentAnalyticsMapper);
            }

            response.RecentlyAddedItems.Source = mappedProducts[0].source === undefined ? null : mappedProducts[0].source;
            _gtmService.push(response.RecentlyAddedItems, productClickAddAllTrolleyAnalyticsMapper);
            _gtmService.push(response.RecentlyAddedItems, addAllToTrolleyAnalyticsMapper);

            // We need to find the item within the response for full product details
            const addedStockcodes = _.map(items, 'stockcode');
            this.recentlyChangedItems = _.filter(getAllProducts.call(this), product => _.includes(addedStockcodes, product.Stockcode));
            // We push to analytics directly because adding multiple items is separate from adding a single item
            // The caller of addItemsToTrolley should specify an event to push
            this._pushTrolleyDataToDtm(response);
            return response;
        });
};

TrolleyService.prototype.saveTrolleyAsList = function (name) {
    _analyticsService.pushEvent(_eventsDtm.SAVE_TROLLEY_LIST);
    return this._trolleyRoute.one('SaveAsList').doPOST({ Name: name });
};

TrolleyService.prototype.hasAvailableProducts = function () {
    return this.trolleyProducts.length > 0;
};

module.exports = TrolleyService;



// WEBPACK FOOTER //
// ./src/shop/trolley/trolley.service.js